/// <reference path='../_all.ts' />


module solution {
  /**
   * Angular Service http://stackoverflow.com/questions/19447886/how-can-i-define-an-angularjs-service-using-a-typescript-class-that-doesnt-poll
   */
  export class SolutionService {
    static $inject = ['$http', '$q', 'CacheFactory','$injector',];

    private cacheName : string = "solutionCache"; //use different cache with capacity, because we can't store anything right now.
    
    constructor(
      // Add the parameter and type definition.
      public $http: ng.IHttpService,
      public $q: ng.IQService,
      public CacheFactory: CacheFactory.ICacheFactory,
      private $injector : ng.auto.IInjectorService
    ) {

        if ($injector.has("editorService")) {
          var editor : editor.IEditorService = <editor.IEditorService>$injector.get('editorService');
          editor.subscribeOnSaveContent(null, (event: ng.IAngularEvent, filter: editor.EditorFilter, data: string) => {
            if (!filter.rpv || !filter.rpv[0] || !filter.rpv[1]) return; //not our concern
            var url : string = "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Solution/ByGroup?PageId=" + pglob.RouteData.PageId
            var cacheKey = url + ":" + filter.rpv[0].Id + "-" + filter.rpv[1].Id;
            var dataCache : CacheFactory.ICache = this.CacheFactory.get(this.cacheName);
            dataCache.remove(cacheKey);
          });
        }

       
    
    } 

    private getOrCreateCache() : CacheFactory.ICache {
      if (!this.CacheFactory.get(this.cacheName)) {
        this.CacheFactory.createCache(this.cacheName, {
          capacity: 10, //currently results in 1MB max size.
          storageMode: 'sessionStorage', // This cache will use `sessionStorage`.
        });
      }
      return this.CacheFactory.get(this.cacheName);
    }

    public getSolutionData() : ng.IPromise<SolutionData> {
      var url : string = "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Solution/ByGroup?PageId=" + pglob.RouteData.PageId
      var cacheKey = url + ":" + pglob.RouteData.RouteEntry.RouteParameterStack[0].Id + "-" + pglob.RouteData.RouteEntry.RouteParameterStack[1].Id

      var deferred = this.$q.defer<SolutionData>();
      var dataCache : CacheFactory.ICache = this.getOrCreateCache();

      //in cache?
      if (dataCache.get(cacheKey)) {
        deferred.resolve(dataCache.get(cacheKey));
        return deferred.promise;
      } 

      //embeded in html?
      var dataEl = document.getElementById('solution-data');
      if (dataEl) {
        var data : SolutionData = JSON.parse(dataEl.innerHTML);
        if (data.Current.RouteParameterStack[0].Id == pglob.RouteData.RouteEntry.RouteParameterStack[0].Id 
          && data.Current.RouteParameterStack[1].Id == pglob.RouteData.RouteEntry.RouteParameterStack[1].Id) { //only if it's a match

          dataCache.put(cacheKey, data);
          deferred.resolve(data);
          return deferred.promise;
        }
      }

      //fetch from network?
      this.$http<SolutionData>({
          method: "POST"
          , url: url
          , headers: { 'Content-Type': 'application/json' }
          , params: {}
          , data: pglob.RouteData.RouteEntry.RouteParameterStack
      }).then((response : { data : SolutionData}) :any => { //success
        dataCache.put(cacheKey, response.data);
        deferred.resolve(response.data);
      });   
      
      return deferred.promise;   
    }
  }
}
